import Vue from "vue";
import {
  Button,
  Form,
  FormItem,
  Input,
  Menu,
  MenuItem,
  Submenu,
  Row,
  Col,
  Card,
  Dialog,
  Carousel,
  CarouselItem,
  ColorPicker,
  Select,
  Option,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxGroup,
  Message,
  Skeleton,
  SkeletonItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Loading,
  MessageBox,
  Badge,
  Popover,
  Radio,
  Progress,
  Switch,
  DatePicker,
} from "element-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import "./element-variables.scss";

locale.use(lang);

Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Dialog);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(ColorPicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Skeleton);
Vue.use(SkeletonItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tooltip);
Vue.use(Loading);
Vue.use(Badge);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Progress);
Vue.use(Switch);
Vue.use(DatePicker);

Vue.prototype.$ELEMENT = { size: "small", zIndex: 3000 };
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
